import React from 'react'
import styled from 'styled-components'
import { CenteredModal, ModalHeader, ModalButtonContainer } from './SharedStyledComponents'
import { Text } from 'ui'
import { XIcon, GiftIcon } from './icons'
import { ConfirmModalProps } from './types'
import ConfettiContainer from './Confeti'


const Container = styled(CenteredModal)`
height: 320px;
padding: 24px 16px 48px 16px;
width: 514px;
`

const ButtonsContainer = styled(ModalButtonContainer)`
 justify-content: center;
 border-radius: 0 0 16px 16px;
border-top: 1px solid var(--Neutral-Borders-Minimal, #E7E7E7);
background: var(--Neutral-Surface-Minimal, #FFF);
`

const Button = styled.div<{backgroundColor?: string, borderColor?: string}>`
display: flex;
justify-content: center;
align-items: center;
padding: 16px;
border-radius: 8px;
background: ${props => props.backgroundColor ? props.backgroundColor : '#FFF'};
border-radius: 8px;
border: 1px solid ${props => props.borderColor ? props.borderColor : 'var(--Neutral-Borders-Mid, #B0B0B0)'};
width: 238px;
height: 56px;
cursor: pointer;
`

const ConfirmModal: React.FC<ConfirmModalProps> = ({ 
    onClose, 
    onConfirm,
    title, 
    subtitle, 
    confirmButtonText, 
    cancelButtonText, 
    isConfettiVisible, 
    isGiftIconVisible,
    confirmButtonBackground = '#007EFF',
    confirmButtonBorderColor = '#007EFF',
    confirmButtonTextColor = 'white',
    cancelButtonBackground = '#FFF',
    cancelButtonBorderColor = '#B0B0B0',
    cancelButtonTextColor = '#272727'
}) => {
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm()
        }
        onClose()
    }

    return (
        <>
        {isConfettiVisible &&
        <ConfettiContainer />
        }
        <Container>
            {isGiftIconVisible &&
            <GiftIcon />
            }
            <ModalHeader>
                <Text style={{fontSize: '24px'}} weight='bold' textcolor='#272727'>{title}</Text>
                <div style={{cursor: 'pointer'}} onClick={onClose}>
                <XIcon />
                </div>
            </ModalHeader>
            <div>
            <Text size='xl' weight='normal' textcolor='#272727'>{subtitle}</Text>
            </div>
            <ButtonsContainer isFixed={true}>
                <Button onClick={handleConfirm} backgroundColor={confirmButtonBackground} borderColor={confirmButtonBorderColor}>
                    <Text size='xl' weight='bold' textcolor={confirmButtonTextColor}>{confirmButtonText}</Text>
                </Button>
                <Button onClick={onClose} backgroundColor={cancelButtonBackground} borderColor={cancelButtonBorderColor}>
                    <Text size='xl' weight='bold' textcolor={cancelButtonTextColor}>{cancelButtonText}</Text>
                </Button>
            </ButtonsContainer>
        </Container>
        </>
    )
}

export default ConfirmModal